import {
  ArrowDownTrayIcon,
  BuildingOffice2Icon,
  ChartBarIcon,
  LinkIcon,
  TableCellsIcon,
  ClockIcon,
  WalletIcon,
} from '@heroicons/react/24/outline';
import { isAdminRole } from '../../consts/management/users/users';

export const EFFECTIVE_CAPITAL_TABS = [
  { label: 'Effective Capital Summary', navLabel: 'Summary', value: 'capital-summary', permissionId: 'nav-effective-capital-summary', adminOnly: true, financeAccess: true, icon: ChartBarIcon, searchAliases: ['ecr', 'ecs', 'effective capital summary', 'capital summary'] },
  { label: 'Accounts', navLabel: 'Accounts', value: 'accounts', permissionId: 'nav-effective-capital-accounts', adminOnly: true, financeAccess: true, icon: BuildingOffice2Icon },
  { label: 'Transactions', navLabel: 'Transactions', value: 'transactions', permissionId: 'nav-effective-capital-transactions', adminOnly: false, icon: ArrowDownTrayIcon },
  { label: 'Bank Balances', navLabel: 'Bank Balances', value: 'bank-balances', permissionId: 'nav-effective-capital-bank-balances', adminOnly: true, financeAccess: true, icon: WalletIcon },
  { label: 'Cashflow Export', navLabel: 'Cash Flow Export', value: 'cashflow-export', permissionId: 'nav-effective-capital-cashflow-export', adminOnly: true, financeAccess: true, icon: TableCellsIcon },
  { label: 'History', navLabel: 'History', value: 'history', permissionId: 'nav-effective-capital-history', adminOnly: true, financeAccess: true, icon: ClockIcon },
  { label: 'Connect Accounts', navLabel: 'Bank Connections', value: 'connect-accounts', permissionId: 'nav-effective-capital-connect-accounts', adminOnly: true, icon: LinkIcon },
];

export const isEffectiveCapitalTabVisible = (value, user, allowedPermissionIds) => {
  const role = user?.role;
  const isAdmin = isAdminRole(role);
  const isFinance = role === 'FINANCE';
  const tab = EFFECTIVE_CAPITAL_TABS.find((item) => item.value === value);
  if (!tab) return false;
  if (isAdmin) return true;
  if (allowedPermissionIds && !allowedPermissionIds.has(tab.permissionId)) return false;
  return !tab.adminOnly || (isFinance && tab.financeAccess);
};

export const getVisibleEffectiveCapitalTabs = (user, allowedPermissionIds) =>
  EFFECTIVE_CAPITAL_TABS.filter((tab) => isEffectiveCapitalTabVisible(tab.value, user, allowedPermissionIds));
